import { ClockIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid'
import dayjs from 'dayjs'

import { DEFAULT_TIMEZONE } from '@/components/entities/requests/model/constants'
import { getDisplayRangeEnd } from '@/components/shared/datepicker/utils/getDisplayRangeEnd'

import { getDailyPeriodEnd } from './lib/dates'

type Props = {
  periodTo?: Date
  isDaily?: boolean
  errorMessage?: string
}

export const PeriodStatusMessage = ({
  periodTo,
  isDaily,
  errorMessage
}: Props) => {
  if (errorMessage) {
    return (
      <div className="mt-20 flex items-center gap-4 font-semibold text-red-70 text-16 xxs:mt-12">
        <div className="w-16">
          <ExclamationCircleIcon className="h-16 w-16" />
        </div>
        {errorMessage}
      </div>
    )
  }

  const displayPeriodTo =
    periodTo &&
    (isDaily ? getDailyPeriodEnd(periodTo) : getDisplayRangeEnd(periodTo))

  return (
    <div className="mt-20 flex items-center gap-4 font-semibold text-grey-60 text-16 xxs:mt-12">
      <ClockIcon className="h-16 w-16" />
      Действует до:{' '}
      <span className="font-normal text-bronze-40">
        {displayPeriodTo &&
          dayjs(displayPeriodTo).tz(DEFAULT_TIMEZONE).format('HH:mm, D MMMM')}
      </span>
    </div>
  )
}
